export default "__VITE_ASSET__7be33ebb__"